import {
    Grid,
    Spinner,
    Text,
    VStack,
} from '@chakra-ui/react';
import React, { useLayoutEffect, useState } from 'react';
import {
    useAppDispath,
} from 'shared';

// eslint-disable-next-line no-restricted-imports
import {
    fetchAwardsThunk,
    fetchBestImagesGroupThunk,
    fetchCompanyInformationThunk,
    fetchCrewMembersThunk,
    fetchDegustationLeadFormThunk,
    fetchBestPortfolioEventsGroupThunk,
    fetchFaqsThunk,
    fetchCateringEventCategoriesThunk,
    fetchCateringEventFormatsThunk,
    fetchCateringFormatsThunk,
    fetchCulinaryStudioArticleCategoriesThunk,
    fetchDeliveryArticleCategoriesThunk,
    fetchDeliveryArticleTagsThunk,
    fetchOutdoorBarArticleCategoriesThunk,
    fetchSweetShopArticleCategoriesThunk,
    fetchLeadFormThunk,
    fetchPlacesBlockThunk,
} from 'shared/lib';
import { useAppDataProcessState } from '../model/slice';

type LoadAppDataProcessProps = {
    children: React.ReactNode
}

export const LoadAppDataProcess: React.FC<LoadAppDataProcessProps> = ({
    children,
}) => {
    const dispatch = useAppDispath();

    const [loaded, setLoaded] = useState(false);

    const { backgroundUrl } = useAppDataProcessState();

    useLayoutEffect(() => {
        const r1 = dispatch(fetchAwardsThunk());
        const r2 = dispatch(fetchBestImagesGroupThunk());
        const r3 = dispatch(fetchCompanyInformationThunk());
        const r4 = dispatch(fetchDegustationLeadFormThunk());
        const r5 = dispatch(fetchCrewMembersThunk());
        const r6 = dispatch(fetchBestPortfolioEventsGroupThunk());
        const r7 = dispatch(fetchFaqsThunk());
        const r8 = dispatch(fetchCateringEventCategoriesThunk());
        const r9 = dispatch(fetchCateringEventFormatsThunk());
        const r10 = dispatch(fetchCateringFormatsThunk());
        const r11 = dispatch(fetchCulinaryStudioArticleCategoriesThunk());
        const r12 = dispatch(fetchDeliveryArticleCategoriesThunk());
        const r13 = dispatch(fetchDeliveryArticleTagsThunk());
        const r14 = dispatch(fetchOutdoorBarArticleCategoriesThunk());
        const r15 = dispatch(fetchSweetShopArticleCategoriesThunk());
        const r16 = dispatch(fetchLeadFormThunk());
        const r17 = dispatch(fetchPlacesBlockThunk());

        Promise.all([
            r1,
            r2,
            r3,
            r4,
            r5,
            r6,
            r7,
            r8,
            r9,
            r10,
            r11,
            r12,
            r13,
            r14,
            r15,
            r16,
            r17,
        ]).then(() => {
            setLoaded(true);
        });
    }, []);

    return loaded ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <Grid
            backgroundImage={`url(${backgroundUrl})`}
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
        >
            {children}
        </Grid>
    ) : (
        <Grid
            height="100vh"
            width="100vw"
            position="fixed"
        >
            <VStack margin="auto">
                <Spinner color="#E74C3C" borderWidth="4px" margin="auto" />
                <Text color="#000000">Загрузка...</Text>
            </VStack>
        </Grid>
    );
};
